<script setup lang="ts">
import clsx from 'clsx';

const props = defineProps<{ class?: string }>();
const classes = clsx(
  'flex flex-col border-b border-zinc-950/5 p-4 dark:border-white/5',
  '[&>[data-slot=section]+[data-slot=section]]:mt-2.5',
  props.class,
);
</script>

<template>
  <div :class="classes"><slot /></div>
</template>
